import React, {Component} from "react";
import {Link} from "react-router-dom";
import flow1 from "../../../../../assets/img/flow1.png";
import './Warranty.css';
import MetaTags from "react-meta-tags";


class Warranty extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        return (

            <div className="static-pages">
                <MetaTags>
                    <title>保証規定｜プリント基板のネット通販｜KITCUT PCB</title>
                    <meta property="title" content="保証規定｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta name="title" content="保証規定｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta property="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                    <meta name="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                </MetaTags>
                <div className="background-div">

                    {/* ●コンテンツ-3（イメージアイコン）
                保証規定（テキスト・アイコンを使いながら表現）		参考：
                <a href="https://raksul.com/privacy/">
                    保証規定（テキスト・アイコンを使いながら表現） 参考：
                </a>*/}
                    <div className="row">
                        <div>
                            <text className="warranty-title font-size-30">
                                保証規定
                            </text>
                            <div className="spacer"></div>
                        </div>
                        <div className='all-content-font-size'>

                            <p>KITCUTLABO.COM(以下「当サイト」と表記する）を利用して製造された全ての商品は、販売主体であるRIZEN HK
                                LIMITED(以下「RIZEN」と表記する)の定める保証規定が適用されます。</p>
                            {/*<p>保証規定が適用されます。</p>*/}

                            <p>当サイトを利用して商品をご注文・ご購入されたお客様は、下記に示す保証規定の内容をご理解・ご承諾いただいているものとします。</p>
                            <p>なお、お届けする商品には、保証書または保証規定書等は付属されておりません。予めご了承ください。</p>


                        </div>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings">
                            KITCUTLABO.COM保証規定
                        </p>
                        <div className='all-content-font-size'>
                            <p>
                                初期不良に関する保証期間は、RIZENと特段の契約締結無き場合は、お客様お受け取りから1か月間となります。 </p>
                            <p> 内容物確認や動作確認は商品納入後、直ちに行ってください。納入後からお客様での動作確認や内容物確認までの経過期間も保証期間内に含まれますのでご注意ください。 </p>
                            <p> 商品には万全を期しておりますが、万一不具合の場合はアカウント→製品詳細→品質報告窓口よりご連絡ください。なお、当サイトでは全て「センドバック方式」で対応をしております。ご了承ください。 </p>
                            <p> 交換の場合、原則として一旦商品をご返却いただき、RIZENにて内容を確認いたします。確認作業には若干お時間（商品到着後1日～5日）を頂戴します。RIZENまでの運送費用はお客様ご負担にてお願いしております。ご了承ください。 </p>
                            <p> 本サービスのご利用により製造された商品の欠陥（お客様の指示に従ったことにより生じたものを除きます。）に起因して何らかの損害が発生した場合、本サービスのご利用金額の範囲内での保証とさせていただきます。 </p>
                            <p> 当サイトを使用して製造された商品を第三者へ転売した場合、その第三者への直接の保証およびサポートは行なっておりません。第三者の方への直接の保証およびサポートは、第三者へ販売されたお客様にてお願いいたします。 </p>


                        </div>
                    </div>
                    <div className="row">

                        <div className="static-pages-headings ">
                            保証対象外となる場合

                        </div>
                        <p className='all-content-font-size'>
                            下記の場合、保証対象外となりますのでご注意ください。
                        </p>
                        <div className='all-content-font-size'>
                            <ol className="oderList ">
                                <li className='all-content-font-size-padding-bottom'>
                                    お客様の取扱い上の不注意や誤りによる故障や損傷
                                </li>
                                <li className='all-content-font-size-padding-bottom'>天災・火災ならびに公害や異常電圧や指定外の電源（電圧、周波数）の使用、その他外部要因による故障および損傷
                                </li>
                                <li className='all-content-font-size-padding-bottom'> お客様ご自身の修理、改造による故障および損傷（ただし弊社が許可したものは除きます。）
                                </li>
                                <li className='all-content-font-size-padding-bottom'> 接続している他の機器に起因する故障や損傷
                                </li>
                                <li className='all-content-font-size-padding-bottom'> 車両や船舶等(一般商業、工業用途以外）に使用された場合による故障や損傷
                                </li>
                                <li className='all-content-font-size-padding-bottom'> 日本国外での使用による故障や損傷
                                </li>
                                <li className='all-content-font-size-padding-bottom'> 定格および推奨使用環境外での使用による故障や損傷
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div className="row">

                        <div className="static-pages-headings">
                            返品について
                        </div>
                        <div className='all-content-font-size'>
                            <p>
                                商品に欠陥がある場合を除き、返品には応じません。


                            </p>
                            <p> 但し、受注ミスや出荷ミスなど弊社の過失によりお届けした商品が異なる場合には、返品をお受け付けいたします。</p>
                            <p> その際にはアカウント→注文履歴→品質報告窓口よりご連絡下さい。</p>
                        </div>
                    </div>
                    <div className="row">

                        <div className="static-pages-headings">
                            キャンセルについて
                        </div>
                        <div className='all-content-font-size'>
                            <p>
                                当サイトには「基板製造サービス」、「メタルマスク製造サービス」があり、決済完了後のキャンセルは原則お受け付けできません。
                            </p>
                        </div>
                    </div>


                </div>
            </div>

        );
    }


}

export default Warranty;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/Warranty.js